<template>
    <tr>
        <td>
            {{item.geo_point.name}}
        </td>
        <td>
            <i v-if="item.geo_point.is_hotel" class="fa fa-check-circle mr-2 text-primary" aria-hidden="true" title="Sí"></i>
            <i v-else class="fa fa-times mr-2 text-warning" aria-hidden="true" title="No"></i>
        </td>
        <td>
            <i v-if="item.geo_point.is_pickup" class="fa fa-check-circle mr-2 text-success" aria-hidden="true" title="Sí"></i>
            <i v-else class="fa fa-times-circle mr-2 text-danger" aria-hidden="true" title="No"></i>
        </td>
        <td>
            {{item.geo_point.pickup_point != null ? item.geo_point.pickup_point.name : '-'}}
        </td>
        <td>
            {{item.geo_point.sub_zone.name}}
        </td>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="time"
                    v-model="form.hora"
                    placeholder="Hora de paso"
                    class="border"
                    style=""
                >
                </b-form-input>
            </span>
            <span v-else>
                {{item.hora}}
            </span>
        </td>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="text"
                    v-model="form.order"
                    placeholder="Orden"
                    class="border"
                    style=""
                >
                </b-form-input>
            </span>
            <span v-else>
                {{item.order}}
            </span>
        </td>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="text"
                    v-model="form.external_stop_id"
                    placeholder="Id parada externo"
                    class="border"
                    style=""
                >
                </b-form-input>
            </span>
            <span v-else>
                {{item.external_stop_id}}
            </span>
        </td>
        <td>
            <b-button
                class="border"
                size="sm"
                variant="light"
                @click="editRow"
                v-if="!edit"
            >
                <i class="text-center fa fa-wrench fa-fw"></i>
                Editar
            </b-button>
            <b-button
                class="border"
                size="sm"
                variant="light"
                @click="saveChanges"
                v-if="edit"
            >
                <i class="text-center fa fa-save fa-fw"></i>
                Guardar
            </b-button>
            <b-button
                class="border"
                size="sm"
                variant="light"
                @click="showDeleteConfirmation"
            >
                <i class="text-center fa fa-trash fa-fw"></i>
                Eliminar
            </b-button>
            <admin-stop-confirm-delete-modal :stop="item" :activity_group="activity_group" />
        </td>
    </tr>
</template>

<script>
import AdminStopConfirmDeleteModal from './AdminStopConfirmDeleteModal'

export default {
    components: {
        AdminStopConfirmDeleteModal,
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        activity_group: {
            type: Object,
            required: false,
        }
    },
    data() {
        return {
            edit: false,
            form: {
                hora: this.item.hora,
                order: this.item.order,
                external_stop_id: this.item.external_stop_id
            }
        }
    },
    methods: {
        editRow() {
            this.edit = true
            
        },
        async saveChanges() {
            this.edit = false

            const data = {
                stop_schedule_id: this.item.id,
                payload: {
                    ...this.form
                }
            }
            await this.$store.dispatch("stops/updateStopSchedule", data)
            const data2 = {
                'activity_group_id': this.item.activity_group,
            }
            await this.$store.dispatch("stops/loadStopsAdmin", data2)
            this.$notify({
                group: "foo",
                title: "Parada " + this.item.geo_point.name + " editada",
                text: "Se ha editado la información de la parada",
                type: "success",
            });
        },
        showDeleteConfirmation() {
            this.$bvModal.show('deleteStop_' + this.item.id)
        }
    }
}
</script>